import styles from '@components/components/Navigation/components/DesktopNavigation/components/MainNavigation/MainNavigation.module.scss';
import SearchMenu from '@components/components/Navigation/components/SearchMenu/SearchMenu';
import iconWeTheme from '@components/images/logo/logo-we-theme-regular.svg';
import iconPositions from '@components/images/logo/logo-positions-regular.png';
import useMainNavigation from '@components/components/Navigation/components/DesktopNavigation/components/MainNavigation/hooks/useMainNavigation';
import React from 'react';
import { FontAwesomeProIcon, Image, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import { Menu, MenuItem, MenuButton } from '@ariakit/react';

const MainNavigation = ({
  isReduced,
  noSubMenu,
  mainMenu,
  layoutStructure,
  className,
}) => {
  const {
    navRef,
    logoRef,
    itemsRef,
    moreRef,
    searchRef,
    regularItems,
    moreItems,
    menu,
    isLoading,
    isSearchOpen,
    handleSearchOpen,
    displayOnlyActiveItem,
    setDisplayOnlyActiveItem,
  } = useMainNavigation(mainMenu, isReduced);

  return (
    <nav
      aria-label="Hauptmenü"
      className={classNames(
        styles.menu,
        {
          [styles.noSubMenu]: noSubMenu,
          [styles.navigationReady]: !isLoading,
        },
        className,
      )}
      ref={navRef}
    >
      <ul className={styles.menuList}>
        <li className={styles.menuListItem}>
          <Link
            aria-current={layoutStructure.isLandingPage ? 'page' : 'false'}
            aria-label={layoutStructure.logoLinkDescription}
            className={classNames(styles.menuListItemLink, styles.isLogo)}
            ref={logoRef}
            target="_self"
            to={layoutStructure.logoLink}
          >
            <Image
              alt=""
              className={styles.logo}
              src={
                layoutStructure?.logoType === 'positions'
                  ? iconPositions
                  : iconWeTheme
              }
            />
          </Link>
        </li>
        {regularItems.map((item, index) => (
          <li
            className={classNames(styles.menuListItem, {
              [styles.isActive]: item.isActive,
              [styles.displayOnlyActiveItem]: displayOnlyActiveItem,
            })}
            key={`regular-${item.id}`}
          >
            <Link
              aria-current={item.isActive ? 'page' : 'false'}
              className={classNames(styles.menuListItemLink)}
              ref={el => {
                itemsRef.current[index] = el;
              }}
              target="_self"
              to={item.url}
            >
              {item.title}
            </Link>
          </li>
        ))}
        {moreItems.length !== 0 && (
          <li
            className={classNames(
              styles.menuListItem,
              styles.moreMenuListItem,
              {
                [styles.displayOnlyActiveItem]: displayOnlyActiveItem,
              },
            )}
            ref={moreRef}
          >
            <MenuButton
              aria-label="Weitere Menüpunkte anzeigen"
              className={styles.moreButton}
              store={menu}
            >
              Mehr
              <FontAwesomeProIcon
                aria-hidden
                className={styles.chevronDown}
                icon="chevron-down"
                role="presentation"
              />
            </MenuButton>
            <Menu className={styles.moreMenu} store={menu}>
              {moreItems.map(item => (
                <MenuItem
                  className={styles.moreMenuItem}
                  key={`more-${item.id}`}
                  onClick={() => menu.toggle()}
                  render={
                    <Link target="_self" to={item.url}>
                      {item.title}
                    </Link>
                  }
                />
              ))}
            </Menu>
          </li>
        )}
      </ul>
      {!isReduced && (
        <SearchMenu
          handleSearchOpen={handleSearchOpen}
          isSearchOpen={isSearchOpen}
          ref={searchRef}
          setDisplayOnlyActiveItem={setDisplayOnlyActiveItem}
        />
      )}
    </nav>
  );
};

export default MainNavigation;
